import ResourceManager from "@/components/common/ResourceManager";
import { eur, fdate } from "@/lib/format";

const CATS = ["Carburant", "Recharge", "Entretien", "Réparation", "Pneus", "Assurance", "Leasing", "Péage", "Parking", "Amendes", "Autres"];
const vehLabel = (id, lookups) => {
  const v = (lookups.vehicles || []).find((x) => x.id === id);
  return v ? `${v.brand} ${v.model} (${v.registration})` : "—";
};
const urlFilters = {
  mois: {
    label: (v) => `Mois : ${new Date(`${v}-01`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" })}`,
    test: (r, v) => String(r.date || "").slice(0, 7) === v,
  },
};

export default function Expenses() {
  const columns = [
    { key: "date", label: "Date", render: (r) => fdate(r.date) },
    { key: "vehicle_id", label: "Véhicule", render: (r, l) => vehLabel(r.vehicle_id, l) },
    { key: "category", label: "Catégorie", render: (r) => <span className="inline-flex rounded-full bg-[#EEF2F8] px-2.5 py-0.5 text-xs font-medium text-[#001A3B]">{r.category}</span> },
    { key: "description", label: "Description" },
    { key: "amount", label: "Montant", render: (r) => <span className="font-semibold">{eur(r.amount)}</span> },
  ];
  const fields = [
    { key: "vehicle_id", label: "Véhicule", type: "vehicle", full: true },
    { key: "category", label: "Catégorie", type: "select", options: CATS },
    { key: "date", label: "Date", type: "date" },
    { key: "amount", label: "Montant (€)", type: "number" },
    { key: "description", label: "Description", full: true },
  ];
  return <ResourceManager title="Dépenses" subtitle="Vision financière consolidée de la flotte." resource="expenses" exportCollection="expenses" columns={columns} fields={fields} lookupsNeeded={["vehicles"]} defaultForm={{ category: "Carburant" }} urlFilters={urlFilters} />;
}
